import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../hooks/store';
import axios from 'axios';
import { get } from '../../utils/api';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket, faRotate } from '@fortawesome/free-solid-svg-icons';
import { authLogout } from '../../store/authSlice';
import './Logout.css';
import Modal from '../common/Modal';
import { Form } from '@alxgrn/react-form';

const Logout = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
	const dispatch = useAppDispatch();
	const [isLoading, setIsLoading] = useState(false);
    const [ isModalOpen, setIsModalOpen ] = useState(false);

	const logout = async () => {
        setIsModalOpen(false);
		setIsLoading(true);
		const result = await get('/attendees/logout');
		if(result.error) {
			console.error(result.error.text[lang]);
		} 
        delete axios.defaults.headers.common['Authorization'];
		dispatch(authLogout());
        setIsLoading(false);
	};

	return (
        <div className='Logout'>
            {isLoading ?
                <Icon icon={faRotate} className='fa-spin' fixedWidth/> :
                <Icon icon={faRightFromBracket} fixedWidth onClick={() => setIsModalOpen(true)}/>
            }
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <h1>{t('profile.logout.title')}</h1>
                <Form
                    info={t('profile.logout.confirm')}
                    submit={t('profile.logout.submit')}
                    onSubmit={() => logout()}
                />
            </Modal>
        </div>
	);
};

export default Logout;
